import { supabase } from '@/integrations/supabase/client';

export type PostAuthPath = '/dashboard' | '/onboarding';

/** Where to send a signed-in user: dashboard if they have a property, else onboarding. */
export async function getPostAuthPath(userId: string): Promise<PostAuthPath> {
  const { data: membership } = await supabase
    .from('hotel_members')
    .select('hotel_id')
    .eq('user_id', userId)
    .limit(1)
    .maybeSingle();

  return membership?.hotel_id ? '/dashboard' : '/onboarding';
}
